export default __webpack_public_path__ + "static/media/easyEight.85106827.png";